webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Vhome_vue__ = __webpack_require__(12);
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    VHome: __WEBPACK_IMPORTED_MODULE_0__components_Vhome_vue__["a" /* default */]
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isClick: false,
      isAndroid: false,
      isPC: false,
      isWX: false,
      isQQ: false,
      isAlipay: false,
      userAgent: navigator.userAgent
    };
  },

  methods: {
    download_vhome_iphone: function download_vhome_iphone() {
      console.log('Vhome iphone download');
      setTimeout(function () {
        window.location.href = 'https://itunes.apple.com/cn/app/创维唯家/id1174744453?mt=8';
      }, 3000);
    },
    download_vhome_android: function download_vhome_android() {
      console.log('Vhome android download');
      // window.location.href = 'https://play.google.com/store/apps/details?id=com.starmakerinteractive.starmaker&hl=zh_CN'
      // 直接下载apk
      window.location.href = 'http://dl.cdn.doubimeizhi.com/weijiaapk/vhome-latest.apk';
    },
    download_vhome: function download_vhome() {
      console.log('Vhome PC download');
      // 直接下载apk
      window.location.href = 'http://dl.cdn.doubimeizhi.com/weijiaapk/vhome-latest.apk';
    }
  },
  created: function created() {
    console.log('Vhome create ua: ', navigator.userAgent);
    var ua = navigator.userAgent;
    this.isWX = !!/MicroMessenger/i.test(ua);
    this.isQQ = !!/QQ\//i.test(ua);
    this.isAlipay = !!/AlipayClient/i.test(ua);
    if (/Android|iPhone|iPad/i.test(ua)) {
      var isAndroid = navigator.userAgent.toLowerCase().indexOf('android') > -1 || navigator.userAgent.toLowerCase().indexOf('adr') > -1;
      this.isAndroid = isAndroid;
      this.isPC = false;
      var from = window.location.href;
      window.location.href = 'weijia://weijia?from=' + encodeURIComponent(from);
    } else {
      // 如果是PC端打开则直接下载apk文件
      this.isPC = true;
    }
  },
  mounted: function mounted() {
    console.log('mounted');
    document.addEventListener('visibilitychange', function () {
      console.log('visibilitychange hidden: ' + document.hidden);
      // window.location.href = 'weijia://weijia'
    });
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(9);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62593b00_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(15);
function injectStyle (ssrContext) {
  __webpack_require__(10)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62593b00_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Vhome_vue__ = __webpack_require__(3);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a90a436a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Vhome_vue__ = __webpack_require__(14);
function injectStyle (ssrContext) {
  __webpack_require__(13)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Vhome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a90a436a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Vhome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"con"},[_c('img',{staticClass:"bg",attrs:{"src":"static/img/Vhome_Bg.jpg"}}),_vm._v(" "),_c('div',{staticClass:"btnBlock"},[(_vm.isPC || !_vm.isAndroid)?_c('img',{staticClass:"btn",attrs:{"src":"static/img/IPhoneDownload.png"},on:{"click":_vm.download_vhome_iphone}}):_vm._e(),_vm._v(" "),(_vm.isPC || _vm.isAndroid)?_c('img',{staticClass:"btn",attrs:{"src":"static/img/AndroidDownload.png"},on:{"click":_vm.download_vhome}}):_vm._e()])]),_vm._v(" "),(!_vm.isClick && this.isAndroid && (this.isWX || this.isQQ || this.isAlipay))?_c('div',{staticClass:"reminder_title",on:{"click":function($event){_vm.isClick = true}}},[_c('img',{staticClass:"arrow_bg",staticStyle:{"display":"block"},attrs:{"src":"static/img/pic_arrow.png"}}),_vm._v(" "),_c('img',{staticClass:"literal_bg",staticStyle:{"display":"block"},attrs:{"src":this.isWX?'static/img/pic_android_literal.png':'static/img/pic_weixin_literal.png'}})]):_vm._e(),_vm._v(" "),(!_vm.isClick && !this.isAndroid && (this.isWX || this.isQQ || this.isAlipay))?_c('div',{staticClass:"reminder_title",on:{"click":function($event){_vm.isClick = true}}},[_c('img',{staticClass:"arrow_bg",staticStyle:{"display":"block"},attrs:{"src":"static/img/pic_arrow.png"}}),_vm._v(" "),_c('img',{staticClass:"literal_bg",staticStyle:{"display":"block"},attrs:{"src":'static/img/pic_ios.png'}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('main',[_c('VHome')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[4]);


// WEBPACK FOOTER //
// static/js/app.7bdea8dbd7f39b65eb0e.js